import KnockWidget from '@cbgms/components/widgets/Knock'
import { useTranslation } from 'react-i18next'
import { deleteLicenseForCompany, getLicensesForCompany } from '../../../state/actions'
import { useParams } from 'react-router-dom'
import navigation from 'utils-support/navigation'
import { useDispatch } from 'react-redux'
import { ILicense } from '@cbgms/api'
import qs from 'query-string'
import { useNotifier } from '@cbgms/base/notifier'
import LicenseExtensionCell from './LicenseExtentionsCell'
import EditButton from './EditButton'
import { QueryParamAllShops } from './HaynesUtils'
import { mapRejectionToMessage } from 'core/page/DeleteErrors'
import { Box, Button, Typography } from '@mui/material'

const fields = ['Distributor.LicenseType', 'Distributor.Name', { key: 'License.LicenseExtension', Component: LicenseExtensionCell }]

const apiFields = [
  'Distributor.LicenseType',
  'Distributor.Name',
  'Distributor.LicenseSettings',
  'License.LicenseSettings',
  'License.ValidFrom',
  'License.ValidTill',
  'License.LicenseExtension'
]

const CompanyLicenses = () => {
  const { companyUUID } = useParams<{ companyUUID?: string }>()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const allShop = true

  if (!companyUUID) {
    return null
  }

  const onDelete = async (row: { License: ILicense }, dryRun: boolean) => {
    await dispatch(deleteLicenseForCompany(row.License.UUID, dryRun))

    if (!dryRun) {
      notifier.success(t('companyLicense.deleted_success'))
    }
  }

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant='h6'>{t('company.licenses.title-companies')}</Typography>
        <Button
          variant='outlined'
          color='primary'
          data-testid='translations-reload'
          onClick={() => navigation.push(`/companies/${companyUUID}/licenses/new?${qs.stringify({ [QueryParamAllShops.key]: allShop })}`)}
          sx={{ ml: 1 }}
        >
          {t('company.licenses.add_new')}
        </Button>
      </Box>

      <KnockWidget
        fields={fields}
        apiFields={apiFields}
        noResultsMessage='global.search_no_results_found'
        action={getLicensesForCompany}
        query='License.ShopID|ISNULL|,License.CompanyUUID|=|'
        queryValue={companyUUID}
        button={row => <EditButton row={row} companyUUID={companyUUID} allShop={allShop} />}
        deleteOptions={{
          onDelete,
          translationKey: 'companyLicense',
          mapApiResponseToMessage: mapRejectionToMessage
        }}
      />
    </>
  )
}

export default CompanyLicenses
